<template>
  <div>
    <div v-if="expanded" class="bg-white border-brand-sand border-2 rounded-xl relative px-4 py-4 mx-auto w-8/12">
      <div class="flex space-x-6">
        <div class="text-xs space-y-1">
          <p class="font-semibold text-brand-black">Enable Extra Offer</p>
          <p class="text-brand-brown font-medium">Surface more aggressive offers if others are declined. Use sparingly.</p>
        </div>
        <div>
          <el-button @click="ctaClick" type="plain" class="border-brand-gray-blue border-2 px-4 py-2 rounded-lg">
            <span class="text-xs text-brand-blue font-semibold">Enable Step →</span>
          </el-button>
        </div>
      </div>
    </div>
    <div v-else class="mx-auto">
      <!-- a simple circle button with a plus sign -->
      <div class="flex items-center justify-center">
        <el-tooltip effect="dark" placement="right" popper-class="brand-tooltip">
          <div slot="content">Enable a final offer step</div>
          <div
            class="border-brand-sand bg-brand-sand border-2 rounded-full w-10 h-10 flex items-center justify-center cursor-pointer"
            @click="toggleExpanded"
          >
            <font-awesome-icon :icon="['fas', 'plus']" class="text-brand-brown text-xl"></font-awesome-icon>
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'FlowStepFinalOfferEmpty',
  components: {},
  props: {},
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    ctaClick() {
      this.$emit('cta-click');
    },
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
  },
  computed: {},
};
</script>
